<template>
  <router-view />
</template>

<script>

export default {
  name: 'AdministratorPage'
}
</script>
